import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VList,
    { staticClass: "pa-4" },
    _vm._l(_vm.languages, function (language) {
      return _c(
        VListItem,
        {
          key: language.iso,
          staticClass: "d-flex align-center justify-center cursor-pointer",
          attrs: { "data-qa": `language-${language.iso}`, width: "260px" },
          on: {
            click: function ($event) {
              return _setup.redirectToOtherLanguage(language)
            },
          },
        },
        [
          _c(VImg, {
            staticClass: "mr-4",
            attrs: {
              src: language.flag_image.url,
              width: "24px",
              alt: language.iso,
            },
          }),
          _vm._v(" "),
          _c(VListItemTitle, [
            _vm._v(
              "\n      " +
                _vm._s(
                  language.translations[`name_${language.iso}`] || language.name
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          language.iso === _setup.currentLanguage.iso
            ? _c(VIcon, { attrs: { color: "primary", size: "24" } }, [
                _vm._v("\n      ui-icon-check\n    "),
              ])
            : _vm._e(),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }